module.exports = __webpack_public_path__ + "static/media/strangerthings-02.37dd213a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/moments-searching/strangerthings-02.jpg
// module id = 205
// module chunks = 0